import React from 'react';
import { 
    Edit, 
    SimpleForm, 
    NumberInput,
    ReferenceInput,
    SelectInput,
    DateInput,
    BooleanInput,
    required,
    usePermissions
} from 'react-admin';
import { FormToolbar } from "../../common/FormToolbar";
import { processPermissions } from "../../common/roleUtils";

export const FeeStructureEdit = props => {
    const { permissions } = usePermissions();
    let propsObj = { ...props };
    
    if (permissions) {
        // Use utility function to process permissions with role-based restrictions
        const processedPermissions = processPermissions(permissions, props.resource);
        propsObj = { ...propsObj, ...processedPermissions };
    }
    
    return (
        <React.Fragment>
            <Edit label="Edit Fee Structure" {...propsObj}>
                <SimpleForm toolbar={<FormToolbar {...propsObj} hasDelete={true}/>} className="main-form">
                    <ReferenceInput 
                        source="branch_id" 
                        reference="branch" 
                        label="Branch"
                        className="first_inline_input"
                    >
                        <SelectInput optionText="branch_name" validate={[required()]} fullWidth={true} />
                    </ReferenceInput>
                    
                    <ReferenceInput 
                        source="program_id" 
                        reference="program" 
                        label="Program"
                        className="last_inline_input"
                    >
                        <SelectInput optionText="program_name" validate={[required()]} fullWidth={true} />
                    </ReferenceInput>
                    
                    <ReferenceInput 
                        source="class_id" 
                        reference="genere" 
                        label="Class"
                        className="first_inline_input"
                    >
                        <SelectInput optionText="class_name" validate={[required()]} />
                    </ReferenceInput>
                    
                    <ReferenceInput 
                        source="section_id" 
                        reference="section" 
                        label="Section (Optional)"
                        className="last_inline_input"
                    >
                        <SelectInput 
                            optionText="section" 
                            helperText="Leave empty for general fee applicable to all sections. Select specific section for differentiated pricing."
                            
                            emptyText="All Sections (General Fee)"
                        />
                    </ReferenceInput>
                    
                    <SelectInput 
                        source="board" 
                        label="Board" 
                        choices={[
                            { id: 'RBSE', name: 'RBSE' },
                            { id: 'CBSE', name: 'CBSE' },
                            { id: 'IGCSE', name: 'IGCSE' },
                        ]} 
                        validate={[required()]}
                        fullWidth={true}
                    />
                    
                    <NumberInput 
                        source="registration_fee" 
                        label='Registration Fee (₹)' 
                        fullWidth={true}
                        className="first_inline_input"
                        min={0}
                        helperText="One-time registration and admission fee"
                    />
                    
                    <NumberInput 
                        source="study_material_fee" 
                        label='Study Material Fee (₹)' 
                        fullWidth={true}
                        className="first_inline_input"
                        min={0}
                        helperText="Cost of study materials and course content"
                    />
                    
                    <NumberInput 
                        source="deliverable_fee" 
                        label='Deliverable Fee (₹)' 
                        fullWidth={true}
                        className="first_inline_input"
                        min={0}
                        helperText="Cost of project and assignment deliverables"
                    />
                    
                    <NumberInput 
                        source="tech_support_fee" 
                        label='Tech Support Fee (₹)' 
                        fullWidth={true}
                        className="last_inline_input"
                        min={0}
                        helperText="Technical support and platform fee"
                    />
                    
                    <NumberInput 
                        source="tuition_fee" 
                        label='Tuition Fee (₹)' 
                        fullWidth={true}
                        className="first_inline_input"
                        validate={[required()]}
                        min={0}
                        helperText="Main tuition fee (Concession applies only to this)"
                    />
                    
                    <NumberInput 
                        source="installment_count" 
                        label='Number of Installments' 
                        fullWidth={true}
                        className="last_inline_input"
                        validate={[required()]}
                        min={1}
                        max={12}
                        helperText="How many installments to split the total fee into"
                    />
                    
                    <DateInput 
                        source="effective_from" 
                        label='Effective From' 
                        fullWidth={true}
                        className="first_inline_input"
                        validate={[required()]}
                    />
                    
                    <DateInput 
                        source="effective_to" 
                        label='Effective To' 
                        fullWidth={true}
                        className="last_inline_input"
                        helperText="Leave blank if no end date"
                    />
                    
                    <BooleanInput 
                        source="is_active" 
                        label="Active" 
                    />
                </SimpleForm>
            </Edit>
        </React.Fragment>
    );
}
